import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import PDFServiceContent from './pdf-services-content.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const WrapperComponent = makeShortcode("WrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left" id="AWS" mdxType="TitleBlock" />
    <h2 {...{
      "id": "adobe-acrobat-services-api"
    }}>{`Adobe Acrobat Services API`}</h2>
    <WrapperComponent slots="content" theme="light" className="div-flex overflow-hidden pricing-wrapper" mdxType="WrapperComponent" />
    <PDFServiceContent mdxType="PDFServiceContent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      